module.exports = __webpack_public_path__ + "img/like.2e877dcb.svg";